export const DEFAULT_FAVORITE_COLOR = 'rgba(245, 166, 35, 1)'
export const DEFAULT_FAVORITE_BGCOLOR = 'rgba(245, 166, 35, 0.1)'
export const DEFAULT_LABEL_COLOR = 'rgba(245, 166, 35, 1)'
export const DEFAULT_WARNING_COLOR = 'rgba(245, 166, 35, 0.1)'

export const ACTIVE_COLOR = '#4099ff'
export const WARNING_COLOR = '#FF5370'
export const DEFAULT_COLOR = '#495057'
